const firstTimeModalSuccess = {
  'first-time-modal-success-title': 'Fertig!',
  'first-time-modal-success-message': 'Du hast dich erfolgreich für unseren Newsletter angemeldet. Bitte öffne deine E-Mails und schließe die Verifizierung ab, um unsere Updates zu erhalten.',
  'first-time-modal-email-domain-not-fund': 'E-Mail-Dienst nicht erkannt. Bitte öffnen Sie Ihre E-Mails manuell.'
};

export default firstTimeModalSuccess;
